import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[ui-button-outlined]',
})
export class UiButtonOutlinedDirective {
  constructor() {}
  @HostBinding('class') elementClass = 'ui-button-outlined';
}
